/* eslint-disable camelcase */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import { raw } from 'core-js/fn/string'
// import { random } from 'core-js/fn/number'
const emojiRegex = require('emoji-regex/RGI_Emoji.js')
const { indexOf } = require('stringz')
const bigInt = require('big-integer')

Vue.use(Vuex, axios)

export default new Vuex.Store({
  state: {
    playlist_keyword: '',
    gdoc_video_key: 'gsx$ytlinkfull',
    gdoc_section_key: 'gsx$sectionnum',
    gdoc_num_sections: 21,
    video_matrix: {},
    engine_playlist: [],
    engine_index_list: [],
    current_video: {},
    current_section: -1,
    tags_list: [],
    locations_list: [],
    people_list: [],
    preferred_people: [],
    preferred_tags: [],
    preferred_locations: [],
    history: [],
    section_titles: ['Opening', 'Girl Who Drove', 'Freedom', 'Ordinary Senior Year', "Driver's Test", 'Top Ten', 'Simple As That', 'Proposal', 'There Was A Party', 'The Mad Ones', 'The Sun', 'I Know My Girl', 'Miles To Go', 'Say The Word', 'Moving On', 'Go Tonight', 'Run Away With Me', 'Drive', "I Didn't Say Goodbye", 'Remember This', 'Closing'],
    ascii_list: '0123456789ABCDEFGHIJ',
    emoji_list: ['✡️', '🚤', '😻', '🍛', '🚬', '🇼🇸', '🥒', '🇻🇬', '🇵🇼', '🌆', '💴', '💽', '😿', '🔷', '📑', '🔓', '💧', '🌃', '👊', '🇳🇨', '🇻🇮', '🇵🇷', '🎲', '💷', '🏯', '👖', '🤣', '🏤', '🍠', '🤏', '🦨', '✍️', '🇪🇹', '♠️', '🇨🇦', '🔟', '🦪', '😛', '💵', '🚴', '😾', '🇸🇱', '👕', '🙊', '🎁', '🇸🇽', '🌰', '🛑', '🙋', '☘️', '❎', '💩', '🚜', '🛺', '🇸🇻', '🇵🇾', '🐜', '🤲', '🦜', '🤳', '🍩', '🧏', '🇬🇼', '◼️', '🇨🇨', '🧿', '🔐', '♣️', '🔻', '🌼', 'ℹ️', '🇰🇵', '😸', '🚰', '🧉', '🧽', '🟧', '👲', '🏃', '🦑', '🟢', '👝', '👛', '🚾', '🃏', '🎅', '🚂', '👎', '🤚', '🍷', '🇱🇻', '🇦🇴', '🚀', '🖤', '❔', '🚋', '🧝', '🌏', '🍶', '🧥', '🙎', '🇪🇪', '😅', '👂', '🇮🇱', '🔰', '🏁', '🈲', '🥅', '5️⃣', '⏰', '🐮', '🈁', '🚵', '🍪', '📶', '📀', '😹', '🚸', '🆘', '🐪', '🎶', '🇷🇼', '😣', '🏅', '🍮', '🎽', '🎮', '💠', '🟡', '🔏', '🙏', '💜', '🇲🇦', '🔞', '🍸', '🇩🇪', '🚶', '🇬🇪', '➿', '🐌', '❣️', '🍄', '🇸🇴', '🥏', '🥡', '🩰', '🍍', '🚄', '🤍', '🧮', '🥣', '😑', '🤝', '👏', '🧡', '🙅', '🦄', '🇬🇺', '🇺🇾', '1️⃣', '🇪🇬', '🟩', '🧯', '🤥', '💳', '🇮🇨', '🩳', '🚲', '🧨', '🛬', '🇧🇴', '🧓', '🎐', '🇹🇷', '6️⃣', '🧑', '🇲🇰', '↙️', '🇰🇬', '🇬🇮', '🇮🇸', '🐾', '🇲🇳', '📳', '🇹🇰', '🚺', '📫', '🇸🇲', '🇼🇫', '♦️', '💀', '🦢', '🇧🇾', '🧊', '🧸', '👐', '🇸🇰', '💃', '👪', '㊗️', '🦀', '🛫', '🇨🇷', '🌙', '💒', '😶', '⬆️', '💔', '🕚', '🔩', '👤', '🦧', '🪂', '📡', '🍊', '🇨🇬', '😚', '👗', '🦂', '🟥', '🥵', '🏦', '🎆', '📪', '🇪🇸', '🦐', '™️', '🇳🇪', '🎯', '🎿', '🇳🇷', '🇫🇮', '🔽', '👷', '🇫🇷', '🍻', '🇱🇺', '🧶', '😎', '👵', '↪️', '🇲🇬', '🇬🇾', '🇱🇦', '🗼', '🆗', '🐠', '〰️', '🕧', '🪐', '👀', '🪓', '🐘', '📿', '☹️', '🇯🇲', '🥾', '🌱', '🇧🇫', '⏳', '🦝', '🇲🇨', '💈', '🔙', '🚖', '🇨🇰', '🍖', '🔇', '🉐', '🌹', '🇧🇭', '⤴️', '🍑', '💤', '❓', '📁', '✏️', '🐆', '💱', '🥝', '🥨', '😍', '🌅', '👱', '🏠', '🧔', '🎍', '🤑', '🧺', '🧪', '🥛', '🥯', '📮', '🦔', '💲', '🌛', '🦴', '💮', '🇰🇳', '🦸', '🍓', '👧', '🕞', '🇹🇲', '🍬', '🍙', '⚜️', '🇸🇪', '💾', '🔝', '🇦🇿', '🛴', '💰', '*️⃣', '🆓', '🍈', '🧈', '🍭', '🇦🇽', '🧂', '🙀', '🇨🇭', '🙉', '😗', '🇩🇲', '🇲🇲', '🇻🇨', '🥌', '🌽', '😲', '🙃', '🕍', '💄', '🚒', '🔁', '🐉', '📭', '💣', '🐰', '🕙', '🎸', '😦', '🐩', '🇱🇧', '👳', '🍱', '🍚', '🇬🇳', '👢', '🇨🇻', '🔡', '💌', '⛹️', '🍫', '↕️', '🇦🇹', '🇬🇫', '📓', '🔒', '🥪', '📜', '🔛', '🎭', '☸️', '🇲🇩', '🇧🇦', '🐀', '🇸🇮', '🆕', '🇻🇦', '🌘', '🔴', '🌳', '🙌', '🌝', '📂', '🚷', '🌀', '🐐', '🕑', '🅿️', '🩺', '🔚', '🍗', '🔘', '🔋', '🛀', '🏡', '😓', '👫', '🧜', '🐴', '💙', '🦎', '☝️', '🐍', '📋', '✳️', '🇬🇦', '🐯', '🥟', '🇬🇧', '🚈', '🇳🇬', '🇷🇺', '😳', '🔸', '🇯🇪', '🥖', '🇸🇸', '🇦🇺', '🐃', '🇧🇧', '😯', '🌾', '🚠', '🗽', '🤛', '🦦', '🟣', '☺️', '🚦', '👃', '🍧', '🧣', '🔖', '👥', '👮', '🈹', '◀️', '🇯🇴', '🇾🇹', '😋', '🇸🇭', '🚟', '🚼', '🏧', '😕', '🤿', '🇸🇷', '↔️', '🇲🇸', '⚗️', '👔', '🔱', '🚯', '🧍', '😥', '🥴', '👄', '🧵', '💼', '🈂️', '🎹', '🇿🇼', '🇪🇨', '👾', '🙈', '🎷', '👍', '🔆', '☂️', '🐇', '🌋', '🧫', '🌚', '🚝', '🤟', '🚐', '💍', '😠', '🦯', '💋', '🧄', '🦉', '®️', '💏', '😃', '🐕', '🧗', '🧹', '🔜', '🇳🇿', '🍿', '🇧🇲', '🕥', '🇷🇸', '🚧', '📬', '🎏', '🅰️', '🐅', '📅', '📱', '👑', '🧀', '🐹', '🚕', '♥️', '💭', '🇱🇸', '💓', '🕛', '🕟', '🧃', '🦇', '💡', '🇳🇺', '🔠', '🇲🇶', '⚛️', '🍎', '🏨', '🚍', '👚', '🎡', '📗', '🧧', '⏫', '💨', '🍒', '🥂', '👰', '👋', '😜', '🇻🇪', '😺', '📣', '🎰', '🧰', '✂️', '🇹🇯', '🌟', '📰', '😵', '🌴', '📛', '👟', '🧤', '🍌', '🦋', '🕗', '🐢', '🥧', '🎎', '🍺', '💚', '🔵', '🎻', '🇧🇪', '🍂', '🏴', '🇮🇷', '🇬🇷', '🇹🇭', '#️⃣', '📎', '🌜', '🦍', '📢', '🍘', '🇨🇿', '🇸🇾', '🥬', '🏐', '⚖️', '🥀', '🌷', '🔫', '🐶', '🇰🇾', '😰', '🛌', '🎴', '👶', '🇻🇳', '📺', '🇲🇱', '🇭🇹', '🔌', '🌁', '🎤', '🤙', '🇫🇰', '🎃', '🥐', '🦖', '🌲', '🇬🇬', '🍁', '🌕', '🐛', '👺', '😌', '🇰🇼', '👅', '🧴', '📲', '🍼', '🔄', '🐋', '🍉', '🇬🇶', '📼', '☄️', '🥘', '💫', '🍐', '🤓', '🇪🇺', '⬇️', '🚥', '🇧🇸', '🆖', '🔀', '🇬🇵', '🚱', '📘', '🎓', '🇵🇫', '🏉', '🥍', '🤽', '🤩', '🚔', '🐺', '🌞', '🚁', '🌇', '🇸🇦', '🎣', '📹', '🔪', '🚩', '😖', '💹', '💆', '🥦', '👒', '🇭🇳', '🥮', '😬', '😡', '🤡', '🧒', '🪒', '💉', '😧', '🚫', '🤷', '💖', '🔧', '🚻', '🚗', '🤐', '👻', '🙁', '📧', '☣️', '📒', '😩', '⏏️', '😘', '🕜', '🌑', '🇹🇴', '🦊', '🟫', '☀️', '🐧', '🤫', '🤰', '🇵🇬', '🚊', '🏭', '🟨', '🥢', '😄', '🇬🇲', '🥞', '☁️', '🥄', '🇷🇴', '🇱🇨', '2️⃣', '🔉', '🇹🇳', '📩', '⁉️', '🦟', '🇨🇩', '😱', '🐒', '📤', '🏳️', '📴', '✒️', '🇿🇲', '📸', '🔥', '🇲🇺', '🇲🇭', '🔂', '🅾️', '🐲', '🌺', '🌻', '🩲', '🏬', '🇷🇪', '🚙', '🎀', '🇳🇦', '🙍', '🤮', '🤨', '🔕', '🙄', '‼️', '🇲🇷', '🐨', '🥽', '🐚', '🎺', '🔈', '🎈', '🇨🇲', '💸', '🇹🇫', '📌', '🧾', '🦾', '🤸', '👈', '😝', '🇹🇻', '🤦', '🤪', '🥑', '😨', '🙂', '👇', '🦩', '🐂', '↩️', '😮', '🍹', '🇲🇹', '😆', '🚨', '🇵🇦', '🤱', '📙', '🐵', '🐈', '🛷', '🇴🇲', '📵', '♨️', '🕖', '🦶', '🥔', '🥓', '🍨', '◻️', '👸', '📕', '🔗', '▪️', '🇵🇲', '🈷️', '🇸🇩', '🇹🇨', '🦙', '🐽', '🇬🇹', '🇫🇯', '🇲🇴', '🌌', '🟪', '💪', '🚇', '🤯', '🛹', '🗾', '✅', '🖕', '🥊', '🔯', '🎢', '🇮🇳', '🎒', '🛕', '☢️', '✊', '🇦🇫', '☠️', '🇪🇭', '💦', '🥼', '🏊', '3️⃣', '🤬', '🥇', '😭', '🏈', '🚮', '🏣', '😙', '➗', '📔', '🎦', '🚽', '💞', 'Ⓜ️', '🕎', '©️', '🎂', '🚭', '🍣', '🦵', '✈️', '🐟', '📚', '🔼', '😉', '🏩', '✝️', '📉', '👬', '🍝', '🙆', '↘️', '🚛', '🥶', '💿', '🚃', '🐝', '🇲🇼', '🆑', '🍜', '🕝', '✨', '⤵️', '🇬🇱', '✉️', '🍴', '⚱️', '🐔', '🥱', '🔊', '🛂', '🦗', '🩱', '🧁', '💇', '🐸', '🟤', '🤞', '🇦🇼', '🇨🇴', '🇰🇷', '🍾', '🛶', '🛃', '🚚', '🚪', '🏂', '🇨🇱', '🧠', '🇮🇩', '🇾🇪', '😇', '😏', '🇬🇩', '🎊', '🇨🇫', '😴', '🌮', '↗️', '🧎', '🇨🇽', '🇸🇨', '🥕', '➕', '🐡', '🧳', '🐻', '🇮🇲', '🐙', '🆎', '🎋', '👠', '🚘', '🥺', '🌓', '🇮🇪', '🕡', '🎳', '❕', '📍', '🌯', '🐣', '💥', '🐑', '📝', '🉑', '🌿', '📨', '🏀', '🔹', '🏇', '🇧🇼', '🍤', '🇵🇳', '🧟', '💝', '🌵', '🙇', '⏪', '🥰', '🧚', '🦒', '🍇', '🎇', '🟦', '🔶', '🥠', '🤗', '🤧', '▫️', '🇸🇬', '🍦', '📻', '😈', '🆚', '🤾', '👡', '🚞', '💎', '🖖', '🐷', '😫', '🦅', '🎪', '🔣', '🇨🇮', '👭', '🍅', '💁', '😼', '🚹', '🦏', '🤴', '📥', '🔢', '🍃', '💛', '😷', '🕔', '🇰🇿', '🏸', '🇲🇪', '🇦🇶', '🕓', '📈', '🛅', '🎬', '🍞', '🎨', '🈳', '🇮🇹', '🚓', '🧞', '🕋', '💗', '👹', '🚌', '🚑', '🤜', '🍆', '👼', '☑️', '🩸', '🤼', '⌨️', '↖️', '❄️', '🔦', '🇦🇸', '🥜', '🎧', '🕺', '🌒', '📄', '🇫🇲', '🇱🇹', '🏋️', '🎩', '😟', '㊙️', '🇧🇩', '➖', '🎉', '🦞', '🦷', '🦚', '😒', '☃️', '⚙️', '🇹🇱', '🛸', '🎱', '🎌', '🤔', '👉', '🎑', '💂', '🎥', '🕢', '💯', '🇲🇻', '🍋', '🔔', '🥁', '🔍', '🥫', '🌖', '🇹🇼', '🌍', '📐', '🦁', '😔', '🌸', '🐥', '🤵', '🍔', '8️⃣', '🇳🇱', '🆔', '🇻🇺', '🛄', '🧩', '📖', '🇹🇹', '🦆', '🇧🇯', '♻️', '🇱🇷', '🈶', '🔳', '👩', '🛵', '🐗', '😤', '🔅', '✋', '🌐', '🤶', '👿', '4️⃣', '👦', '🔬', '🕕', '🇭🇰', '🇭🇺', '🤠', '🥳', '🇯🇵', '🇲🇿', '🧲', '🧦', '✴️', '🥗', '🈵', '🐖', '🌔', '⬅️', '🈴', '🔤', '🇺🇸', '🇲🇽', '🌎', '😊', '👨', '🌊', '🧱', '🇱🇾', '⚠️', '🕒', '🇲🇵', '🧢', '👙', '🇩🇯', '🇱🇮', '🥤', '☎️', '👌', '🍟', '🧆', '🦕', '🕤', '🐤', '🏄', '🕐', '🇵🇹', '☯️', '🔺', '🦿', '🇦🇩', '🚅', '🎼', '🔃', '🇽🇰', '🛐', '🏺', '🇦🇷', '🐄', '🥋', '🥻', '🇧🇷', '👽', '🏢', '🌉', '🏓', '⏬', '🇲🇾', '☪️', '🇨🇺', '😁', '😽', '😞', '💢', '🇺🇦', '🍢', '🇵🇭', '🏆', '🚉', '🐊', '🛒', '🏰', '🧭', '🌭', '⚰️', '🇧🇬', '🇿🇦', '🦮', '🟠', '🧙', '🇶🇦', '🇹🇿', '🦛', '🇳🇫', '💕', '🧖', '🪁', '🏪', '🔨', '🔭', '🪑', '🇺🇳', '🇨🇼', '🩹', '🦡', '📦', '🚆', '🇦🇬', '🇧🇱', '🇰🇮', '💑', '🎾', '😀', '❇️', '🤢', '🧐', '🧅', '🪔', '🏫', '🏮', '🚏', '😪', '🐫', '☦️', '✖️', '🐞', '🇰🇪', '🦈', '🔎', '🇹🇩', '🕦', '🇸🇿', '🥙', '🌂', '🐼', '🇭🇷', '🤖', '🧬', '🇩🇴', '🇦🇱', '📏', '🎠', '🥎', '🇧🇳', '🈸', '🤭', '❤️', '🦻', '😐', '🚡', '🧷', '🍀', '🇳🇮', '🦌', '💟', '🏹', '🥉', '👞', '🥭', '💅', '🕣', '📷', '🇫🇴', '💘', '🐭', '🦹', '🍰', '🇳🇵', '🇧🇮', '➰', '💺', '🐱', '🏏', '🇰🇭', '🧛', '👆', '🥈', '🦃', '7️⃣', '〽️', '👘', '🇵🇰', '🤺', '🇹🇬', '🇦🇮', '🔮', '🇪🇷', '📟', '🏌️', '🇺🇬', '🇧🇿', '🇧🇶', '🏑', '👜', '🛁', '☮️', '🍯', '💶', '🔑', '🥚', '➡️', '🏥', '🪀', '❌', '🍵', '🦥', '🍳', '🇦🇪', '🥥', '📊', '⏩', '🚎', '👯', '🇵🇱', '🇱🇰', '🕘', '🇮🇶', '🌗', '🧻', '🕠', '0️⃣', '🇩🇰', '🤹', '👴', '🍲', '🕌', '📞', '🦺', '📆', '💻', '🇦🇲', '👓', '🚢', '🧼', '🇸🇳', '🐳', '🚳', '🇨🇾', '📯', '📃', '🦓', '🇸🇧', '🦽', '🐓', '🍏', '🏒', '🦠', '🗿', '⚔️', '🍥', '🅱️', '🧕', '🎫', '🎄', '😢', '9️⃣', '🍕', '🇵🇸', '🇧🇹', '🐏', '🚿', '🥩', '🌄', '🐬', '👣', '🇬🇭', '💐', '🇺🇿', '🌠', '⛎', '🇳🇴', '🤕', '🤘', '✌️', '🥿', '😂', '🐁', '🦼', '🤎', '🇩🇿', '🈺', '🦘', '🥃', '🍡', '🗻', '🪕', '🤒', '🤤', '💬', '🐎', '🚣', '💊', '🧇', '🇬🇸', '▶️', '📇', '📠', '🆒', '🔲', '🇰🇲', '🇵🇪', '✔️', '🇨🇳', '🧘', '🐦', '🆙', '🇮🇴', '🌈', '🎵']
  },
  getters: {
    getPlaylistEmojiCode: state => {
      const playlistString = state.engine_index_list.join('-')
      // const playlistString = '1-3-1-0-3-3-1-0-1-1-0-2-1-2-1-1-0-2-0-3-1'
      const textLen = state.ascii_list.length
      const emojiList = state.emoji_list
      const emojiLen = emojiList.length
      const textList = state.ascii_list

      function recurEmoji (dec) {
        const oper = dec.divmod(bigInt(emojiLen))
        const x = oper.remainder
        const rest = oper.quotient
        if (Number(rest) === 0) {
          return emojiList[Number(x)]
        }
        return recurEmoji(rest) + emojiList[Number(x)]
      }

      let total = bigInt(0)
      let currPow = 0
      for (let i = 0; i < playlistString.length; i++) {
        let encChar = ''
        let nexti = i

        if (playlistString[i + 1] === '-') {
          // skip the next one and convert this into the lettercode to save space
          encChar = textList[textList.indexOf(playlistString[i]) + 10]
          nexti = i + 1
        } else {
          encChar = playlistString[i]
        }

        total = total.add((bigInt(textLen).pow(currPow)).times(bigInt(textList.indexOf(encChar.toString()))))
        i = nexti
        currPow++
      }
      const result = recurEmoji(total)

      return result
    },
    getPlaylistString: state => {
      return state.engine_index_list.join('-')
    },
    getCurrentSectionTitle: state => {
      return state.section_titles[state.current_section]
    }
  },
  mutations: {
    setPreferredTags (state, payload) {
      state.preferred_tags = payload
    },
    setPreferredLocations (state, payload) {
      state.preferred_locations = payload
    },
    setPreferredPeople (state, payload) {
      state.preferred_people = payload
    },
    setVideoId (state, payload) {
      state.video_id = payload
    },
    createEngine (state, payload) {
      // make a temp array of arrays based on the (hardcoded) num_sections above
      // eslint-disable-next-line prefer-const
      let tempMatrix = new Array(state.gdoc_num_sections)
      const tempTags = []
      const tempLocations = []
      const tempPeople = []

      // eslint-disable-next-line no-useless-escape
      // const youtubeRegex = RegExp('.*?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})')
      // const googleMapRegex = RegExp('http.*/@(?<lat>-?\d*\.\d*),(?<lon>-?\d*\.\d*),(?<zzz>\d*z).*')

      for (let z = 0; z < tempMatrix.length; z++) {
        tempMatrix[z] = []
      }
      payload.forEach(ele => {
        const i = Number(ele[state.gdoc_section_key].$t)

        const pretags = ele.gsx$pretagslist.$t.split(', ')
        const customtags = ele.gsx$tagslist.$t.split(',')
        const peopleCombos = ele.gsx$teamroleslist.$t.split(' * ')

        const thesePeople = []
        const theseTags = []

        pretags.forEach(tag => {
          if (tempTags.indexOf(tag.trim().toUpperCase()) < 0) {
            tempTags.push(tag.trim().toUpperCase())
          }
          theseTags.push(tag.trim().toUpperCase())
        })
        customtags.forEach(tag => {
          if (tempTags.indexOf(tag.trim().toUpperCase()) < 0) {
            tempTags.push(tag.trim().toUpperCase())
          }
          theseTags.push(tag.trim().toUpperCase())
        })

        if (tempLocations.indexOf(ele.gsx$tlcity.$t.trim() < 0)) {
          tempLocations.push(ele.gsx$tlcity.$t.trim())
        }

        peopleCombos.forEach(person => {
          const x = person.split('- ')
          // x[1] is the person. x[0] is the role
          if (x.length !== 2) {
            console.log(`INCORRECT PEOPLE PARSED: Section ${i} | ${x}`)
          } else {
            if (tempPeople.indexOf(x[1].trim()) < 0) {
              tempPeople.push(x[1].trim())
            }
            thesePeople.push(x[1].trim())
          }
        })

        ele.locations = [ele.gsx$tlcity.$t.trim()]
        ele.people = thesePeople
        ele.tags = theseTags

        if (i === 20) {
          if (ele.gsx$section20option.$t === 'Opening') {
            // console.log('i20 opening found')
            ele.gsx$sectionnum.$t = 0
            tempMatrix[0].push(ele)
          } else {
            // console.log('i20, no opening found')
            tempMatrix[20].push(ele)
          }
        } else {
          tempMatrix[i].push(ele)
        }
      })

      state.video_matrix = tempMatrix
      state.tags_list = tempTags.sort()
      state.locations_list = tempLocations.sort()
      state.people_list = tempPeople.sort()

      // for (let t = 0; t < tempMatrix.length; t++) {
      //   for (let r = 0; r < tempMatrix[t].length; r++) {
      //     console.log(`Section ${t} | Index ${r} | Video ${tempMatrix[t][r].gsx$ytlinkfull.$t}`)
      //   }
      // }
    },
    createPlaylist (state, payload) {
      const playlistLen = state.video_matrix.length
      const tempPlaylist = []
      const tempIndexList = []

      function randomListIndex (items) {
        return Math.floor(Math.random() * items.length)
      }

      for (let x = 0; x < playlistLen; x++) {
        const sectionVids = state.video_matrix[x]
        let availVids = []

        let whatIsAForLoop = 0 // this is a hack because i'm a terrible programmer on a deadline
        sectionVids.forEach(vid => {
          const people_test = vid.people.filter(ele => state.preferred_people.includes(ele))
          const tags_test = vid.tags.filter(ele => state.preferred_tags.includes(ele))
          const locations_test = vid.locations.filter(ele => state.preferred_locations.includes(ele))
          // console.log(people_test)
          // console.log(tags_test)
          // console.log(locations_test)
          // console.log('====================')
          vid.match_sum = people_test.length + tags_test.length + locations_test.length
          vid.match_list = people_test.concat(tags_test).concat(locations_test)
          vid.section_index = whatIsAForLoop
          if (vid.match_sum > 0) {
            availVids.push(vid)
          }
          whatIsAForLoop++
        })

        // if there were no tag matches, just select from everything
        if (availVids.length === 0) {
          availVids = sectionVids
          console.log(`no videos for section ${x}`)
        }
        console.log(`videos for section ${x}: ${availVids.length}`)

        const i = randomListIndex(availVids)

        // if (state.preferred_people.length > 0 || state.preferred_tags.length > 0 || state.preferred_locations.length > 0) {
        //   const vid = state.video_matrix[x][i]
        //   const people_test = vid.people.filter(ele => state.preferred_people.includes(ele))
        //   const tags_test = vid.tags.filter(ele => state.preferred_tags.includes(ele))
        //   const locations_test = vid.locations.filter(ele => state.preferred_locations.includes(ele))

        //   if (people_test.length > 0 || tags_test.length > 0 || locations_test > 0) {
        //     tempPlaylist.push(state.video_matrix[x][i])
        //     tempIndexList.push(i)
        //   } else {

        //   }
        // } else {
        //   tempPlaylist.push(state.video_matrix[x][i])
        //   tempIndexList.push(i)
        // }

        tempPlaylist.push(availVids[i])
        tempIndexList.push(availVids[i].section_index)
      }

      // now make the ending the same as the beginning
      const zeroEmail = tempPlaylist[0].gsx$tlemail.$t

      for (let x = 0; x < state.video_matrix[state.video_matrix.length - 1].length; x++) {
        if (state.video_matrix[state.video_matrix.length - 1][x].gsx$tlemail.$t === zeroEmail) {
          // console.log(`MATCHED! ${zeroEmail}`)
          tempPlaylist[tempPlaylist.length - 1] = state.video_matrix[state.video_matrix.length - 1][x]
          break
        }
      }

      state.engine_playlist = tempPlaylist
      state.engine_index_list = tempIndexList
      state.current_section = -1
      state.history = []
    },
    loadPlaylist (state, payload) {
      // should be a 1-2-3-4-5-6 formatted string
      const playlist = payload.split('-')
      const engine = []

      if (playlist.length !== state.video_matrix.length) {
        console.log(`Invalid Playlist: Playlist Length ${playlist.length} != ${state.video_matrix.length}`)
        return null
      }

      for (let i = 0; i < playlist.length; i++) {
        if (state.video_matrix[i].length < Number(playlist[i])) {
          console.log(`Invalid Playlist: Index ${i} | ${playlist[i]} > ${state.video_matrix[i].length}`)
          return null
        }
        engine.push(state.video_matrix[i][playlist[i]])
      }

      state.engine_index_list = playlist
      state.engine_playlist = engine
    },
    loadEmojiPlaylist (state, payload) {
      const textLen = state.ascii_list.length
      const emojiList = state.emoji_list
      const emojiLen = emojiList.length
      const textList = state.ascii_list

      function recurText (dec) {
        const oper = dec.divmod(bigInt(textLen))
        const x = oper.remainder
        const rest = oper.quotient
        // eslint-disable-next-line eqeqeq
        if (Number(rest) == 0) {
          return textList[Number(x)].toString()
        }
        return recurText(rest) + textList[Number(x)].toString()
      }

      let total = bigInt(0)
      const regex = emojiRegex()
      const emojiListStr = emojiList.join('')

      console.log(payload.match(regex))

      const regexTry = payload.match(regex)
      if (!regexTry) {
        return ''
      }
      const regexMatch = regexTry.reverse()

      for (let i = 0; i < regexMatch.length; i++) {
        total = total.add((bigInt(emojiLen).pow(i)).times(indexOf(emojiListStr, regexMatch[i])))
      }

      const rawResult = recurText(bigInt(total))
      let result = []
      for (let i = 0; i < rawResult.length; i++) {
        if (textList.indexOf(rawResult[i]) > 9) {
          result.push('-')
          result.push(textList[textList.indexOf(rawResult[i]) - 10])
        } else {
          result.push(rawResult[i])
        }
      }
      result = result.reverse().join('')
      console.log(result)

      const playlist = result.split('-')
      const engine = []

      if (playlist.length !== state.video_matrix.length) {
        console.log(`Invalid Playlist: Playlist Length ${playlist.length} != ${state.video_matrix.length}`)
        return null
      }

      for (let i = 0; i < playlist.length; i++) {
        if (state.video_matrix[i].length < Number(playlist[i])) {
          console.log(`Invalid Playlist: Index ${i} | ${playlist[i]} > ${state.video_matrix[i].length}`)
          return null
        }
        engine.push(state.video_matrix[i][playlist[i]])
      }

      state.engine_index_list = playlist
      state.engine_playlist = engine
    },
    setShuffle (state, payload) {
      function pseudoRandomListIndex (items, avoid) {
        if (items.length < 1) {
          return 0
        }
        let rando = Math.floor(Math.random() * items.length)
        while (rando === avoid) {
          rando = Math.floor(Math.random() * items.length)
        }

        return rando
      }
      const currPlaylistIndex = state.engine_index_list[state.current_section]
      const newIndex = pseudoRandomListIndex(state.video_matrix[state.current_section], currPlaylistIndex)
      state.current_video = state.video_matrix[state.current_section][newIndex]
    },
    setPlayerState (state, payload) {
      // payload should be the next section index
      if (payload > state.engine_playlist.length) {
        console.log('No more videos.')
      } else {
        // update the history to the current state
        const history = []
        for (let i = 0; i < payload; i++) {
          const googleUrl = state.engine_playlist[i].gsx$tlgooglemap.$t
          // console.log(googleUrl)
          const regex = /http.*\/@(?<lat>-?\d*\.\d*),(?<lng>-?\d*\.\d*),(?<zzz>\d*z).*/

          const theMatch = googleUrl.match(regex)

          // console.log(theMatch)

          history.push({
            index: i,
            name: `Section ${i}`,
            lat: theMatch.groups.lat,
            lng: theMatch.groups.lng,
            z: theMatch.groups.zzz
          })
        }

        state.current_video = state.engine_playlist[payload]
        state.current_section = payload
        state.history = history
      }
    }
  },
  actions: {
    getVideoMatrix (state) {
      // console.log("AXIOS IS FIRING")
      // const tmoEngineDemoUrl = 'https://spreadsheets.google.com/feeds/list/1IeUEfjgEBsl2rF1bo2qa6EEMb6RgBeLgtV2UzufQGR4/2/public/values?alt=json'
      const tmoEngineDemoUrl = 'https://spreadsheets.google.com/feeds/list/1cpI1dwCzDDzYQvvv-hvBIv1Pn13QHj5R2uj4GgE4P7g/2/public/values?alt=json'
      // const cyoa_demo_url = "https://spreadsheets.google.com/feeds/list/1tlGxgWRq9bhdiDrcu42_tF-yw94IKxQpBl6Lxr7tfdg/1/public/values?alt=json"
      axios
        .get(tmoEngineDemoUrl)
        .then(response => (
          state.commit('createEngine', response.data.feed.entry)
        ))
        // .then(() => state.commit('createPlaylist', ''))
        // .then(() => state.dispatch('nextVideo'))
    },
    nextVideo (state) {
      console.log('NEXT VIDEO IS FIRING')

      state.commit('setPlayerState', this.state.current_section + 1)
    }
  },
  modules: {
  }
})
